import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row card rounded-0" }
const _hoisted_3 = { class: "col-12 card-header" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-12 col-md-6" }
const _hoisted_6 = { class: "col-sm-12 col-md-6" }
const _hoisted_7 = { class: "input-icons" }
const _hoisted_8 = { class: "col-12 card-body" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-10" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = {
  key: 1,
  class: "row"
}
const _hoisted_19 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pagination = _resolveComponent("pagination")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && !_ctx.err_msg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "row card text-white rounded-0 top-header" }, [
            _createElementVNode("div", { class: "col-12 text-center" }, [
              _createElementVNode("h2", { class: "my-3 fw-bold" }, "Client Admin Requests")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-primary me-5 reset-btn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetRequests()))
                  }, "Reset Filters")
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("i", {
                      class: "fas fa-search",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getRequests()))
                    }),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "search by email",
                      class: "float-end",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email_string) = $event)),
                      onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.getRequests()), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.email_string]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.requests.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requests.slice(_ctx.page_start,_ctx.page_end), (client_request) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: client_request.id,
                          class: "col-6 user-mgmt-card mb-2 pt-2",
                          onClick: ($event: any) => (_ctx.router.push({name:'management.client',params:{request_id:client_request.id}}))
                        }, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("h4", null, [
                                _createTextVNode(_toDisplayString(client_request.user.name) + " ", 1),
                                (client_request.is_sim)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_14, "Simclusive"))
                                  : (_openBlock(), _createElementBlock("small", _hoisted_15, "SP-ED"))
                              ]),
                              _createElementVNode("p", null, _toDisplayString(client_request.user.email), 1),
                              _createElementVNode("small", null, "Date Submitted: " + _toDisplayString(_ctx.moment(client_request.created_at).format('MM-DD-YYYY')), 1)
                            ]),
                            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-2 d-flex flex-column justify-content-center" }, [
                              _createElementVNode("h3", { class: "text-center" }, [
                                _createElementVNode("i", { class: "fas fa-arrow-circle-right text-primary float-end" })
                              ])
                            ], -1))
                          ]),
                          _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1))
                        ], 8, _hoisted_11))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        (_ctx.requests.length > 20)
                          ? (_openBlock(), _createBlock(_component_pagination, {
                              key: 0,
                              items: _ctx.requests,
                              page_start: _ctx.page_start,
                              page_end: _ctx.page_end,
                              onNextPage: _ctx.nextPage,
                              onPreviousPage: _ctx.previousPage,
                              label: 'Requests'
                            }, null, 8, ["items", "page_start", "page_end", "onNextPage", "onPreviousPage"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[6] || (_cache[6] = [
                    _createElementVNode("div", { class: "col-12" }, " No requests match search ", -1)
                  ])))
            ])
          ])
        ]))
      : (!_ctx.loading && _ctx.err_msg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _cache[8] || (_cache[8] = _createElementVNode("h4", null, "Error Loading Requests", -1)),
            _createElementVNode("p", null, _toDisplayString(_ctx.err_msg), 1)
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}